/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { BsJustify, BsBoxArrowLeft } from "react-icons/bs";
import { Divider, Typography, Popover, Avatar } from '@mui/material';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui';
import { BrowserView } from 'react-device-detect';
import { logout } from '../../../store/reducers/user/userAction';
import { IMAGES } from '../../../config/assets';


const UserAvatar = () => {
    const [menuHandler, setMenuHandler] = useState({ open: false, anchorEl: null });
    const navigate = useNavigate();
    const user = useSelector(state => state.user.user)
    const { classes } = useStyles();
    const dispatch = useDispatch()
    const handleClose = () => {
        setMenuHandler({ open: false, anchorEl: null });
    };
    const handleClick = (event) => {
        setMenuHandler({ open: !menuHandler.open, anchorEl: event.currentTarget });
    };
    const handleLogout = () => {
        setMenuHandler({ open: false, anchorEl: null });
        dispatch(logout());
        navigate('/login');
    }
    return (
        <>
            <Button aria-controls="simple-menu"
                startIcon={
                    <>
                        <Avatar
                            style={{ width: '35px', height: '35px' }}
                            src={user ? user.useravatar :
                                 IMAGES.AVATAR_DEFAULT
                            }
                        />
                    </>
                }
                aria-haspopup="true" onClick={handleClick}
                style={{ marginLeft: 'auto' }}
            >
                <BrowserView>
                <Typography variant="h3" color="text.primaryLight">{user?.username}</Typography></BrowserView>
            </Button>
            <Popover
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={menuHandler.open}
                onClose={handleClose}
                anchorEl={menuHandler.anchorEl}
            >

                <MenuItem className={classes.barMenuItem} onClick={() => { navigate("/dashboard"); handleClose() }} >
                    <Typography color="primary" variant="h5" className={classes.menyTypo}>
                        <BsJustify className={classes.BarIcon} /> Dashboard
                    </Typography>
                </MenuItem>
                <Divider />
                <MenuItem className={classes.barMenuItem} onClick={() => { navigate("/account"); handleClose() }} >
                    <Typography color="primary" variant="h5" className={classes.menyTypo}>
                        <BsJustify className={classes.BarIcon} />
                        Account
                    </Typography>
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => handleLogout()} className={classes.barMenuItem} >
                    <Typography color="primary" variant="h5" className={classes.menyTypo} >
                        <BsBoxArrowLeft className={classes.BarIcon} />  Logout
                    </Typography>
                </MenuItem>

            </Popover>

        </>
    )

}
const useStyles = makeStyles({ "name": { UserAvatar } })(theme => ({
    menyTypo: {
        margin: '5px',

    },
    BarIcon: {
        marginBottom: '-3px',
        marginRight: '10px'
    },
    barMenuItem: {
        paddingLeft: '5px!important',
        marginLeft: '5px',
        width: "170px",
        "&:hover": {
            color: 'white!important'
        }
    }
}));
 
 
export default UserAvatar;